.panelPaddingRight {
    padding-right: 20px;
    min-height: 440px;
    min-width: 500px;
}

.panelPaddingLeft {
    padding-left: 20px;
    min-height: 440px;
    min-width: 500px;
}
